import { Preset } from "@/utilities/types/archive";


interface GetExpandedPresetsSetArgs {
    presets: Array<Preset>
}

/**
 * returns a set of indices indicating which presets should be expanded on load
 */
export function getExpandedPresetsSet(args: GetExpandedPresetsSetArgs) {
    const {
        presets,
    } = args;

    const expandedPresets = new Set();

    const defaultPresetIdx = presets.findIndex(preset => preset.default);

    if (defaultPresetIdx >= 0) {
        // found default preset. Add its index in the set.
        expandedPresets.add(defaultPresetIdx);
    } else if (presets.length) {
        // default preset not found and there are presets. Add index 0 to the
        // set.
        expandedPresets.add(0);
    }

    return (expandedPresets as Set<number>);
}
